import { render, staticRenderFns } from "./MaterialListComponent.vue?vue&type=template&id=b2d5a554&"
import script from "./MaterialListComponent.vue?vue&type=script&lang=js&"
export * from "./MaterialListComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports